import { View, Text, TouchableOpacity } from "react-native";
import React from "react";
import GlobalStyles from "../../../../../globalStyles/globalStyles";
import OptionsFilter from "../../filterComponents/OptionsFilter";
import { styles } from "../basicFilterStyles";

export default function FilterItemBasic({
  filter,
  label,
  value,
  type,
  component,
  name,
  filters,
  setFilters,
  handlePress,
  advanced,
  multiselect,
}: {
  filter: any;
  label: string;
  value: string;
  type?: string;
  component?: any;
  name: string;
  filters: any;
  setFilters: any;
  handlePress: (
    label: string,
    value: string,
    component: any,
    name: any,
    filters: any,
    setFilters: any,
    advanced?: boolean,
    multiselect?: boolean
  ) => void;
}) {
  return (
    <TouchableOpacity
      style={styles.FilterItem}
      onPress={() => {
        if (type === "optionFilter") {
          handlePress(
            label,
            value,
            <OptionsFilter
              options={filter?.options}
              filters={filters}
              setFilters={setFilters}
              name={name}
              multiselect={filter?.multiselect}
              advanced={advanced}
            />,
            name,
            filters,
            setFilters
          );
        } else {
          handlePress(label, value, component, name, filters, setFilters);
        }
      }}
    >
      <Text style={GlobalStyles.bodyText}>{label}</Text>
      <Text style={[GlobalStyles.bodyText, { opacity: 0.4, marginTop: 4 }]}>
        {value}
      </Text>
    </TouchableOpacity>
  );
}
